import { container } from "tsyringe";

// behaviors
import { AcademyBehavior } from "@/entities/academy/domain/behaviors/AcademyBehavior";
import { UserBehavior } from "@/entities/user/models/behaviors/UserBehavior";

// submitted-action
import {
    SubmittedActionBehavior,
    SubmittedActionBehaviorStructure,
} from "@/entities/submitted-action/domain/behaviors/SubmittedActionBehavior";

// concept-enhancement
import { ConceptEnhancementBehavior } from "@/entities/concept-enhancement/domain/behaviors/ConceptEnhancementBehavior";

// common-accounts
import { CommonAccountsBehavior } from "@/entities/common/interface/common-accounts/domain/behaviors/CommonAccountsBehavior";

// class
import {
    ClassBehaviorStructure,
    ClassBehavior,
} from "@/entities/class/domain/behaviors/ClassBehavior";

// curriculum
import {
    BigUnitBehaviors,
    BigUnitBehaviorStructure,
} from "@/entities/curriculum/domain/behavior/BigUnitBehaviros";

// ai-tutor-session
import {
    AiTutorSessionBehavior,
    AiTutorSessionBehaviorStructure,
} from "@/entities/ai-tutor-session/domain/behaviors/AiTutorSessionBehavior";

export const behaviorRegisterInit = () => {
    container.register<SubmittedActionBehaviorStructure>("SubmittedActionBehavior", {
        useClass: SubmittedActionBehavior,
    });

    container.register<ConceptEnhancementBehavior>("ConceptEnhancementBehavior", {
        useClass: ConceptEnhancementBehavior,
    });

    container.register<CommonAccountsBehavior>("CommonAccountsBehavior", {
        useClass: CommonAccountsBehavior,
    });

    container.register<AcademyBehavior>("AcademyBehavior", {
        useClass: AcademyBehavior,
    });

    container.register<UserBehavior>("UserBehavior", {
        useClass: UserBehavior,
    });

    container.register<ClassBehaviorStructure>("ClassBehavior", {
        useClass: ClassBehavior,
    });

    container.register<BigUnitBehaviorStructure>("BigUnitBehavior", {
        useClass: BigUnitBehaviors,
    });

    container.register<AiTutorSessionBehaviorStructure>("AiTutorSessionBehavior", {
        useClass: AiTutorSessionBehavior,
    });
};
